<template>
    <!-- 平台介绍 -->
    <div id="myCarousel" class="carousel slide" data-ride="carousel">
        <div class="box">
            <div class="imgTitle">
                <img src="../../assets/img/new/平台介绍.png" alt="图片加载失败">
                <span style="color: aliceblue;">平台介绍</span>
            </div>

            <div class="FourBox">
                <div class="topDiv">
                    <div class="topLeft">
                        <div class="topLeftLeft">
                            <div class="topLeftLeftTitle">场景化融资模式</div>
                            <div class="topLeftLeftContent">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    
                                平台不是一个包罗万象、边界不清的综合金融服务平台，而是聚焦不同的产业、
                                行业、企业经营、政务管理等场景数据，打造独具特色的场景融资模式。
                            </div>
                        </div>

                        <div class="topLeftCenter">
                            <img src="../../assets/img/new/特色融资bg.png" />
                        </div>

                        <div class="topLeftRight">
                            <div class="topLeftRightTitle">全流程融资服务</div>
                            <div class="topLeftRightContent">
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    
                                不同于旨在打破银企信息不对称的简单撮合式融资服务平台，而是一个通过对场景数据的整理、
                                加工和全流程风险管理，实现对银行和企业的精准服务，嵌入到银行获客、贷前风险筛查、
                                贷后风险管理等信贷业务不可或缺的服务平台，同时也是一个完善、培育、提升市场主体信用资质，
                                使其具备融资条件的信用服务平台。

                            </div>
                        </div>
                    </div>

                    <div class="topRight">
                        <div style="margin-top: 20px;">

                            <div class="titleName">
                                <span> 特色场景金融 </span>
                            </div>
                            
                            <div>
                                <div class="topRightContent">
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;充分利用数字+技术+征信等现代金融科技手段，
                                    针对区域经济发展特性和需要，打造独具特色的产
                                    融场景金融服务模式。
                                </div>
                                    <!-- <br /> -->
                                <ul>
                                    <li>⚪创新进取，追求卓越；摒弃形式，注重实效。</li>
                                    <li>⚪践行可实施、可复制、可持续。</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="bottomDiv">

                    <div class="bottomLeft">
                        <div style="margin-top: 20px;">
                            <div class="titleName2">
                                <span> 平台业绩 </span>
                            </div>

                            <div class="parentContainerTop">
                                <div class="achievement01Father">
                                    <div class="achievement01">
                                        <div class="numTop">4182</div>
                                    </div>
                                </div>
                                

                                <div class="achievement02Father">
                                    <div class="achievement02">
                                        <div class="numTop">5688</div>
                                    </div>
                                </div>
                                

                            </div>

                            <div class="achievementContiner">
                                <div class="achievement01Name">家供应商</div>
                                <div class="achievement02Name">笔订单合同</div>
                            </div>
                            
                            
                            <div class="parentContainerBottom">
                                <div class="achievement01Father">
                                    <div class="achievement01">
                                        <div class="numBottom">214.86</div>
                                    </div>
                                </div>

                                <div class="achievement02Father">
                                    <div class="achievement02">
                                        <div class="numBottom">103.44</div>
                                    </div>
                                </div>
                            </div>

                            <div class="achievementContiner">
                                <div class="achievement01Name">亿元授信</div>
                                <div class="achievement02Name">亿元放款</div>
                            </div>
                        </div>
                    </div>

                    <div class="bottomRight">

                        <div class="financing_release">
                            <div class="financing_release_box">
                                <div class="financing_release_imgTitle">
                                    <img src="../../assets/img/new/金币2.png" alt="图片不存在">
                                    <span>融资发布</span>
                                </div>
                                <!-- 边框 下划线 -->
                                <div class="financing_release_underline">
                                    <div></div>
                                </div>
                                <div class="financing_release_data">

                                    <div class="tableCssDiv">
                                        <table class="tableCssSet" border="0" v-for="(item, index) in financingNeedsList" :key="index"
                                            width="95%" v-if="index < 7">
                                            <tr>
                                                <!-- 显示内容 -->
                                                <td style="text-align: left;">
                                                    {{ item.compName }}成功发布债权融资需求&nbsp;&nbsp;
                                                    <span style="color: red;">{{ item.applyForLoansTotal }}</span>&nbsp;&nbsp;万元
                                                </td>
                                                <!-- 时间 -->
                                                <td style="text-align: right;">
                                                    {{ item.loadTime | formatDate }}
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                            
                                </div>
                            </div>
                        </div>

                        <!-- <FinancingRelease></FinancingRelease> -->
                    </div>

                </div>
            </div>


        </div>
    </div>
</template>


<script>

// 导入css样式表
import '../../assets/css/AreaDataImg.css';
import axios from 'axios'
import config from '../../../config/ipConfig'

export default {
    name: "AreaDataImg",
    data() {
        return {
            apiUrl: config.apiUrl,
            dialogVisible: false,
            financingNeedsList: [],//临时存储全部的融资数据
        };
    },
    mounted() {
        this.financingNeedsIndex();

    },
    filters: {
        formatDate: function (value) {
            let date = new Date(value);
            let y = date.getFullYear();
            let MM = date.getMonth() + 1;
            MM = MM < 10 ? ('0' + MM) : MM;
            let d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            let h = date.getHours();
            h = h < 10 ? ('0' + h) : h;
            let m = date.getMinutes();
            m = m < 10 ? ('0' + m) : m;
            let s = date.getSeconds();
            s = s < 10 ? ('0' + s) : s;
            //return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
            return y + '-' + MM + '-' + d;
        }
    },
    methods: {
        financingNeedsIndex() {
            axios.get(this.apiUrl + "/index/financingapplyindex/page?page=1&limit=20").then((response) => {

                this.financingNeedsList = response.data.data.list;
                //console.log(this.financingNeedsList)
                for (let index = this.financingNeedsList.length - 1; index >= 0; index--) {
                    if (this.financingNeedsList[index].financingProgress != 5) {//删除那些融资不通过的  融资通过的是5
                        //console.log("资金到位奥，老铁")
                        this.financingNeedsList.splice(index, 1);
                    }
                }
                var tmpName, tmpTime;
                //替换公司名，脱敏
                for (let index = this.financingNeedsList.length - 1; index >= 0; index--) {
                    //console.log(this.financingNeedsList[index].compName)
                    //公司名大于四个字
                    if (this.financingNeedsList[index].compName.length >= 4) {
                        tmpName = this.financingNeedsList[index].compName.substring(0, 3)
                            + "******" +
                            this.financingNeedsList[index].compName.substring(this.financingNeedsList[index].compName.length - 2, this.financingNeedsList[index].compName.length)
                    } else {
                        tmpName = this.financingNeedsList[index].compName.substring(0, 2)
                            + "******公司"
                    }
                    //替换位置
                    this.financingNeedsList[index].compName = tmpName
                }
            }

            );
        },

    },
};
</script>

<style scoped>
.carousel {
    height: 940px;
    width: 1920px;
    margin-bottom: -0.2rem;
    /* 设置底部外边距为-0.2rem */
    background-size: 100%;
    background-repeat: no-repeat;
    background-image: url('../../assets/img/new/bg.jpg');
}
</style>



// WEBPACK FOOTER //
// src/components/Department_Industry_Finance/AreaDataImg.vue